/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable camelcase */
import React, { FC, ReactNode } from 'react';
import { Button, Modal } from 'antd';
import dialogBg from '@/assets/images/dialogBg.png';
import styles from './index.module.less';

interface Props {
  visible: boolean,
  changeVisible: (v: boolean) => void,
  msg?: string,
}

const Dialog: FC<Props> = ({ visible, changeVisible, msg }: Props) => {
  const str1 = '感谢您对游戏市场洞察系统的关注！';
  const str2 = '本平台所有内容均由IEG市场与用户研究部产出，基于IEG数据安全需要，本平台仅对集团内IEG人员开放（权限将于<b><u>入职次日</u></b>生效）。';
  const str3 = '部分公开内容可在KM平台“互娱用研i-MUR”查阅。';
  const str4 = '如您的岗位与游戏业务高度相关，重要工作需要研究报告/市场用户数据，请联系ronsonhuang(黄润心)，谢谢！';

  if (!visible) return null;

  return (
    <Modal
      visible={visible}
      centered
      title={null}
      footer={null}
      forceRender
      modalRender={(modal: ReactNode) => (
        <div className={styles.dialog}>
          {modal}
        </div>
      )}
      bodyStyle={{
        width: '520px',
        height: '360px',
        backgroundColor: 'transparent',
        backgroundImage: `url(${dialogBg})`,
        backgroundSize: '556px 436px',
        backgroundPosition: '-18px 0px',
      }}
      maskStyle={{ zIndex: 1000000001 }}
      zIndex={1000000002}
    >
      <div className={styles.title}>权限提示</div>
      <div className={styles.text}>
        {msg || (
          <>
            <p>{str1}</p>
            <p dangerouslySetInnerHTML={{ __html: str2 }} />
            <p>{str3}</p>
            <p>{str4}</p>
          </>
        )}
      </div>
      <Button
        onClick={() => {
          changeVisible(false);
        }}
        className={styles.button}
      >
        确认
      </Button>
    </Modal>
  );
};

export default Dialog;
